var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcGermanyFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 7,
    cy: 7,
    r: 7
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.65,
    stroke: "#979797",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#464655",
    d: "M20.0748311,0 L1.62516895,0 C0.727585742,0 0,0.716468722 0,1.60033746 L0,4.66666667 L21.7,4.66666667 L21.7,1.60033746 C21.7,0.716468722 20.9724143,0 20.0748311,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE15A",
    d: "M0,12.3996625 C0,13.2834895 0.727585742,14 1.62516895,14 L20.0748311,14 C20.9723719,14 21.7,13.2835313 21.7,12.3996625 L21.7,9.33333333 L0,9.33333333 L0,12.3996625 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.7,
    height: 4.666,
    y: 4.667,
    fill: "#FF4B55"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGermanyFlag);
export default __webpack_public_path__ + "static/media/ic_germany_flag.84f67b81e47bc2fb0f71fb6c2e0cbe3c.svg";
export { ForwardRef as ReactComponent };